import { render, staticRenderFns } from "./NavierasTipoRecargo.vue?vue&type=template&id=29519f79"
import script from "./NavierasTipoRecargo.vue?vue&type=script&lang=js"
export * from "./NavierasTipoRecargo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports